import React from "react";
import { Avatar, Box, getColor, Tooltip, Typography } from "fds";
import "./index.scss";
import utilsCommon from "../../shared/utils/common";
import { Member } from "../../types/workgroup";
import { t } from "i18next";
interface NameTagProps {
  classes?: string;
  user:
    | Member
    | { userName: string; userId: string; status: number; userType: number };
  minHeight?: string | number;
  height?: string | number;
  width?: string | number;
  withoutUserId?: boolean; // 이름 태그에서 userId 안넣고싶을 경우 사용
  showOnlyOne?: boolean; // 하위 항목에 한개만 표시하고싶은 경우 사용
  nameStrColor?: string; // 이름의 색 지정
  deptStrColor?: string; //이름 하단에 부서명 색 지정
  subLeftIcon?: any;
  avatarSize?: "20" | "24" | "32" | "40" | "48";
}

const NameTag: React.FC<NameTagProps> = ({
  user,
  minHeight,
  width,
  height,
  withoutUserId = true,
  showOnlyOne = false,
  nameStrColor,
  deptStrColor = "#717985",
  subLeftIcon,
  classes,
  avatarSize,
}) => {
  return (
    <Box
      alignItems="center"
      height={height}
      minHeight={minHeight}
      width={width}
      classes={classes}
    >
      <Avatar
        name={user?.userName ? user?.userName : user.userId}
        uniqueCode={utilsCommon.getUserColor(user.userType, user.status, user?.userName)}
        icon={user?.userName ? undefined : "user"}
        subLeftIcon={subLeftIcon}
        size={avatarSize}
      />
      <Box
        classes="mg ml-8"
        direction="column"
        maxWidth={
          user.status !== 1 ? "calc(100% - 138px)" : "calc(100% - 45px)"
        }
      >
        <Tooltip
          message={utilsCommon.getUserNameIdTag(
            user.userId,
            user.userName,
            withoutUserId
          )}
        >
          <Typography ellipsis type="body2_rg">
            {utilsCommon.getUserNameIdTag(
              user.userId,
              user.userName,
              withoutUserId
            )}
          </Typography>
        </Tooltip>
        {"companyName" in user && (
          <Typography
            type="caption1_rg"
            exactColor={deptStrColor}
            classes="mg mt-2"
            ellipsis
          >
            {showOnlyOne
              ? user.companyName ?? user.deptName ?? user.positionName
              : utilsCommon.getUserPositionNDept({
                  positionName: user.positionName,
                  deptName: user.deptName,
                  companyName: user.companyName,
                  userType: user.userType,
                })}
          </Typography>
        )}
      </Box>
      {user.status !== 1 && (
        <Typography
          exactColor={getColor("COLOR_TEXT_ERROR")}
          classes="unregist"
          type="caption1_rg"
          whiteSpace="noWrap"
        >
          {t("common.noRegist")}
        </Typography>
      )}
    </Box>
  );
};
export default NameTag;
